<template>
<div v-show="isBtnVisible" > 
<button class="backToTopBtn btn btn-primary btn-sm" type="button " @click="scrollToTop" >
  <i class="fas fa-arrow-up"></i>
  <p class="mb-0 text-white">TOP</p>
</button>
</div>
</template>

<script>
export default {
  
  data() {
    return {
      isBtnVisible: false,
    };
  },
  methods:{
    handleScroll() {
      // 設定一個閥值（例如200px），當頁面向下滾動超過時顯示按鈕
      this.isBtnVisible = window.scrollY > 80;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },

mounted(){
  window.addEventListener('scroll', this.handleScroll);
}
};
</script>


<style lang="scss" scoped>

.backToTopBtn{
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #46a5836e;
  border: none;


}
</style>
